import React, { Component } from 'react';
import '../styles/styles.css';
import style from '../styles/Style.js';
import { Container, Row, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNodeJs, faReact, faAws, faPython, faMicrosoft, faAppStoreIos, faApple,  } from '@fortawesome/free-brands-svg-icons';
import { faMeteor, } from '@fortawesome/free-solid-svg-icons';

class Projects extends Component {
    render() { 
        return (
            <Container id="projects">
                <Container style={style.aboutMe.card}>
                    <Row className="justify-content-center">
                        <h3 style={{color: style.palette.lightBlue}}>Projects</h3>
                    </Row> 
                    <Row className="justify-content-center">
                        <Card style={style.projects.cardStyle}>
                          <Card.Body>
                            <Card.Title>Coltix Auctions</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">
                                Technologies: <FontAwesomeIcon icon={faNodeJs} size="1x" /> <FontAwesomeIcon icon={faReact} size="1x" /> <FontAwesomeIcon icon={faMeteor} size="1x" />
                            </Card.Subtitle>
                            <Card.Text className="text-justify">
                              Website where people can auction tickets for different events in Colombia.
                              The idea is that the seller, posts their remaining ticket and buyers bid until the 
                              deadline the seller specifies. However, a buy now price is included by the seller,
                              and the buyer can win the auction by bidding this price. A match between the seller
                              and the winner buyer is made.
                            </Card.Text>
                              <a className="a-projects" href="https://github.com/jfmendez11/coltix-auctions" target="_blank" rel="noopener noreferrer">
                                <button className="btn-projects">View Repo</button>
                              </a>
                          </Card.Body>
                        </Card>
                        <Card style={style.projects.cardStyle}>
                          <Card.Body>
                            <Card.Title>SuperVoices</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">
                            Technologies: <FontAwesomeIcon icon={faNodeJs} size="1x" /> <FontAwesomeIcon icon={faReact} size="1x" /> <FontAwesomeIcon icon={faPython} size="1x" /> <FontAwesomeIcon icon={faAws} size="1x" />
                            </Card.Subtitle>
                            <Card.Text className="text-justify">
                              This project was made during the course Development Of Cloud Solutions. The idea is that 
                              companies can create contests for choosing an announcer for their ads. They send the an email
                              with a link to the contest, and participant can upload their voices. If the voice is in
                              a different format than MP3 a worker transforms it to MP3. An email is sent to the participant
                              when the voice has converted and also to the winner when the contest is over.
                            </Card.Text>
                              <a className="a-projects" href="https://github.com/jfmendez11/supervoices" target="_blank" rel="noopener noreferrer">
                                <button className="btn-projects">View Repo</button>
                              </a>
                          </Card.Body>
                        </Card>
                        <Card style={style.projects.cardStyle}>
                          <Card.Body>
                            <Card.Title>Muvsic/suira.co</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">
                            Technologies: <FontAwesomeIcon icon={faNodeJs} size="1x" /> <FontAwesomeIcon icon={faReact} size="1x" /> <FontAwesomeIcon icon={faAws} size="1x" />
                            </Card.Subtitle>
                            <Card.Text className="text-justify">
                              Web application developed in a team of 3. 
                              Social network for musicians. 
                              Designed front-end and transitioned from Ruby to React. 
                              Developed initial database model (NoSQL), initial RESTful backend with NodeJS and a 
                              preliminary version of mail service using Simple Email Service (SES) from AWS and NodeJS.
                            </Card.Text>
                              <a className="a-projects" href="https://github.com/jfmendez11/suira" target="_blank" rel="noopener noreferrer">
                                <button className="btn-projects">View Repo</button>
                              </a>
                          </Card.Body>
                        </Card>
                        <Card style={style.projects.cardStyle}>
                          <Card.Body>
                            <Card.Title>TuristApp</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">
                              Technologies: <FontAwesomeIcon icon={faAppStoreIos} size="1x" /> <FontAwesomeIcon icon={faApple} size="1x" />
                            </Card.Subtitle>
                            <Card.Text className="text-justify">
                              Mobile application for the course Software Engineering for 
                              Mobile Applications: Built an iOS app using Swift programming 
                              language for tourists in Bogotá. Users can search and discover 
                              places around them in Bogotá, they can plan a route to tour the 
                              city and start the route, translate from their native language to 
                              Spanish and use a Forex calculator from COP to their desired 
                              currency, all without tinternet.
                            </Card.Text>
                              <a className="a-projects" href="https://github.com/jfmendez11/TuristApp" target="_blank" rel="noopener noreferrer">
                                <button className="btn-projects">View Repo</button>
                              </a>
                          </Card.Body>
                        </Card>
                        <Card style={style.projects.cardStyle}>
                          <Card.Body>
                            <Card.Title>Neiva's University Hospital Indicator Registration</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">
                            Technologies: <FontAwesomeIcon icon={faNodeJs} size="1x" /> <FontAwesomeIcon icon={faReact} size="1x" /> <FontAwesomeIcon icon={faMicrosoft} size="1x" />
                            </Card.Subtitle>
                            <Card.Text className="text-justify">
                              Web application developed in a group of two. 
                              Built a web application for Neiva’s University Hospital, 
                              which allows de hospital to keep a record of their indicators. 
                              Indicators are registered by users which have permission to modify 
                              that indicator. If they don’t have a permission, de can request one to 
                              the administrator. The app allows users to observe the historic change 
                              of the indicator graphically.
                            </Card.Text>
                              <a className="a-projects" href="https://github.com/af-olivares10/Registro-de-indicadores-HUN" target="_blank" rel="noopener noreferrer">
                                <button className="btn-projects">View Repo</button>
                              </a>
                          </Card.Body>
                        </Card>
                    </Row>  
                </Container>
            </Container>
        );
    }
}

export default Projects;